var render = function render(){var _vm=this,_c=_vm._self._c;return _c('i',{staticClass:"f7",attrs:{"data-f7-icon":_vm.name,"aria-hidden":"true"}})
}
var staticRenderFns = []

export { render, staticRenderFns }